<template>
  <div style="height: 100%;">
    <div
      class="customer-header"
      style="display: flex;"
    >
      <img
        src="@assets/images/default_avatar.svg"
        alt=""
        class="avatar"
      >
      <div class="account-info">
        <div>{{ accountInfo.account_id }}</div>
        <div
          v-if="isIO"
          style="font-size: 12px;"
        >
          当前剩余 {{ accountInfo.count_left }}次
        </div>
      </div>
      <ContactService style="margin-left: auto;" />
    </div>
    <div class="content">
      <div class="product-wrap">
        <!-- 渲染io - product列表 -->
        <div
          :class="['product-card', {'selected' : product.isSelected, 'leads-product': isLeadsPersonal}]"
          v-for="product in renderProductList"
          :key="product.buy_unit"
          @click="chooseProduct(product)"
        >
          <div
            class="discount"
            v-if="product.discount"
          >
            限时 {{ product.discount }}
          </div>
          <div
            class="product-count"
            v-if="product.countStr"
          >
            {{ product.countStr }}
          </div>
          <div
            class="product-price"
            v-if="product.amountStr"
          >
            {{ product.amountStr }}
          </div>
          <div
            class="original-amount"
            v-if="product.discount"
          >
            ¥{{ product.original_amount }}
          </div>
          <div class="product-footer">
            {{ product.footerStr }}
          </div>
        </div>
      </div>
      <ul
        class="tips"
      >
        <li>{{ tipStr }} {{ accountInfo.valid_to }}</li>
      </ul>
      <div
        class="agreement io"
        style="margin-top: 32px;"
      >
        <mm-checkbox
          class="agree"
          v-model="isAgree"
          style="margin-top: -1px;"
        />
        <p v-if="isIO">
          同意
          <a
            :href="`https://${domain}/zh-cn/deep-know`"
            target="_blank"
          >《通用隐私政策》</a>、
          <a
            :href="`https://${domain}/zh-cn/software-services`"
            target="_blank"
          >《服务合同》</a>
          并愿意接收来自 xiaoman.cn 或 okki.com 的服务邮件
        </p>
        <p v-else>
          同意
          <a
            href="https://personal-account.xiaoman.cn/privacy"
            target="_blank"
          >《OKKI个人版软件服务协议及信息授权协议》</a>、
          <a
            href="https://personal-account.xiaoman.cn/aggrement"
            target="_blank"
          >《个人信息传输使用授权书》</a>
          并愿意接收来自 xiaoman.cn 或 okki.com 的服务邮件
        </p>
      </div>
      <mm-button
        type="primary"
        class="submit-btn"
        @click="submitOrder"
      >
        <div
          class="discount"
          v-if="selectedProduct.discount"
        >
          优惠 ¥{{ selectedProduct.discount_amount }}
        </div>
        立即支付
        <span
          v-if="selectedProduct.amount"
          style="font-weight: bold;margin: 0 4px;"
        >¥{{ selectedProduct.amount }} </span>
        <span
          v-if="selectedProduct.discount"
          style="text-decoration: line-through;"
        >¥{{ selectedProduct.original_amount }}</span>
      </mm-button>
    </div>
  </div>
</template>

<script>
import PaymentApi from "@api/payment";
import Servers from "@config";
import ContactService from './ContactService.vue';

export default {
    name: "Payment",
    // 入参 productList
    props: {
        productList: {
            type: Array,
            default: () => []
        },
        accountInfo: {
            type: Object,
            default: () => {}
        },
        /** io 和 leads_personal */
        productType: {
            type: String,
            default: ''
        }
    },
    components: {
      ContactService
    },
    data() {
        return {
            selectedProduct: {},
            isAgree: false,
            submitLoading: false,
            isMobile: false,
            productWrap: null,
        }
    },
    computed: {
      isIO() {
        return this.productType === 'io';
      },
      isLeadsPersonal() {
        return this.productType === 'leads_personal';
      },
      renderProductList() {
        return this.productList.map((product) => {
          let footerStr =  product.discount ? `低至 ${product.unit_amount}` : product.unit_amount;
          if (!this.isIO) {
            footerStr = `${product.amount} 元/${product.unit_duration} 个月`;
          }
          return {
            ...product,
            buy_unit: this.isIO ? product.buy_unit : product.unit_duration,
            discount: product.discount,
            countStr: this.isIO ? `${product.count}次` : product.productName,
            amountStr: this.isIO ? `¥${product.amount}` : product.productDetail,
            footerStr,
            isSelected: this.isIO ?  this.selectedProduct.buy_unit === product.buy_unit : true ,
          }
        });
      },
      tipStr() {
        return this.isIO ? '本次增购次数有效期至' : '本次购买有效期至';
      },
      domain() {
        return location.origin.indexOf('okki.com') > -1 ? 'okki.com' : 'xiaoman.cn';
      },
    },
    created() {
      this.isMobile = /Android|Mobi|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
    },
    mounted() {
      this.productWrap = document.getElementsByName('product-wrap')[0];
    },
    methods: {
        chooseProduct(product) {
            this.selectedProduct = product;
        },
        submitOrder() {
            if (!this.selectedProduct.amount) {
                this.$message.info('请选择购买产品');
                return;
            }
            if (!this.isAgree) {
                this.$message.info('请同意交易协议');
                return;
            }

            // 判断是否为移动端
            this.submitLoading = true;
            const addOrderFunc = this.isIO ? PaymentApi.addOrder : PaymentApi.addLeadsPersonalOrder
            const addOrderParams = this.isIO ? {
                token: this.accountInfo.token,
                ...this.selectedProduct,
                source: 'iomall'
            } : {
                token: this.accountInfo.token,
            }
            addOrderFunc(addOrderParams).then((res) => {
                // 跳转到支付页面
                this.$emit('submitOrder');
                if(this.isMobile) {
                  const host = Servers.oss.includes('https:') ? Servers.oss : ('https:' + Servers.oss);
                  window.location.href = `${host}/internal-api/customer/ali-pay-customer?order_no=${res.order_no}&amount=${this.selectedProduct.amount}`
                }
            }).catch((res)=>{
              if (res.code === -1 && res.msg ) {
                window.location.href = '/payment/fail?msg=' + res.msg;
              }
            }).finally(() => {
                this.submitLoading = false;
            });
        },
    },
    watch: {
      productList: {
        handler() {
          if (this.isLeadsPersonal && this.productList.length > 0) {
            this.selectedProduct = this.productList[0];
          }
        },
        immediate: true,
        deep: true
      }
    }
}
</script>

<style lang="scss" >
@font-face {
  font-family: NumberFont;
  src: url('../../../assets/font/MiSans-Medium.ttf');
}

$theme-color: #0891ff;
$hover-color: #0070D9;

.payment-wrapper{
    width: 100vw;
    height: 100vh;
    background-color: #f5f5f5;
}
.header{
    padding: 20px 24px;
    height: 60px;
    width: 100%;
    background: #fff;
    border-bottom: 1px;
    border-color: #F0F0F0;
    /* 屏幕高度或宽度小于600px时不展示 */
    @media screen and (max-width: 600px) {
        display: none;
    }
}
.container {
    background: #fff;
    height: calc(100% - 60px);
    @media screen and (min-width: 1024px) {
        width: 800px;
        margin: auto;
    }

    @media screen and (max-width: 600px) {
        height: 100%;
    }
}
.customer-header{
    display: flex;
    align-items: center;
    padding: 24px;
    height: 90px;
    width: 100%;
    background: linear-gradient(91.29deg, #00D3D3 0%, #00A3FF 50.52%, #0064FF 100%);
    border-bottom: 1px;
    border-color: #F0F0F0;
}
.avatar{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
}
.account-info {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    margin-left: 12px;
    color: #fff;
}
.content {
    .tips {
        margin-top: 20px;
        // ul的样式 圆点
        padding-left: 22px;
        li {
            font-size: 14px;
            color: #666;
            line-height: 22px;
            list-style: disc;
        }
    }
}
.product-wrap {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(108px, 1fr));
    gap: 16px;
    @media screen and (max-width: 600px) {
        gap: 12px;
    }
}
.product-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #5CA8FF;
    padding: 8px 16px;
    border-radius: 0px 0px 8px 8px;
    width: calc(100% + 2px);
    height: 38px;
    position: absolute;
    bottom: -1px;
    left: -1px;
    right: -1px;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    font-family: NumberFont;

    @media screen and (max-width: 600px) {
      padding: 8px;
    }
  }
.product-card{
    position: relative;
    padding: 20px;
    height: 138px;
    border-radius: 8px;
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.08);
    cursor: pointer;
    text-align: center;
    min-width: 108px;
    max-width: 368px;
    box-sizing: border-box;
    border: 1px solid transparent;

    .discount {
        position: absolute;
        height: 20px;
        padding: 2px 6px;
        border-radius: 8px 4px 8px 0px;
        background: linear-gradient(99deg, #E05409 3.24%, #F9B75C 90.63%);
        font-size: 12px;
        color: #fff;
        font-weight: 600;
        line-height: 16px;
        top: -10px;
        left: -1px;
    }

    .product-count {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
    }

    .product-price {
        color: var(--primary-6, $theme-color);
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px; /* 140% */
        font-family: NumberFont;

        &.leads-product-title {
          font-size: 16px;
        }
    }

    .original-amount {
        text-decoration: line-through;
        color: $theme-color;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        font-family: NumberFont;
        margin-top: 3px;
    }

    &.selected, &.selected:hover {
        border-radius: 8px;
        border-color: $theme-color;
        background: var(--primary-1, #F0F8FF);
        .product-footer {
            background-color:  $theme-color;
        }

        .product-count, .original-amount, .product-price {
            color: $theme-color;
        }
    }

    &:hover {

        .product-price, .original-amount, .product-count {
          color: $hover-color;
        }

        .product-footer {
            background-color: $hover-color;
        }
    }
}

.product-card.leads-product {
  .product-count{
    font-size: 20px;
  }
  .product-price {
    font-size: 14px;
  }
}
</style>
